import { initializeApp } from "firebase/app";
import { getFirestore, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDB-oKAZLRnLnbVdIIqhWfkiUSyE9UB74I",
  authDomain: "robovation.firebaseapp.com",
  projectId: "robovation",
  storageBucket: "robovation.appspot.com",
  messagingSenderId: "629602498874",
  appId: "1:629602498874:web:a3ae61a4739609d69cb803",
};

// init firebase
initializeApp(firebaseConfig);

// init services
const db = getFirestore();
const auth = getAuth();
const storage = getStorage();

// timestamp
const timestamp = Timestamp;

export { db, auth, storage, timestamp };
